import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import api from 'api';

import css from 'css';

import HeadMeta from 'partials/HeadMeta';
import Loader from 'partials/Loader';

import { msg, gtmPush } from 'helpers';

import {
    setCheckoutMinimizeButton,
    setCheckoutVisibility,
    setCheckoutInitStep,
    setCheckoutError,
    setCheckoutCustomerId,
    setCheckoutCustomerPartialObject,
    setCheckoutOpportunityPartialObject,
    setCheckoutOpportunityRegistrationType,
    setCheckoutOpportunityId,
    setCheckoutOpportunityCustomerId,
    setCheckountOpportunityEducationalGoal,
    setCheckoutOpportunityComment,
    setCheckoutOpportunityTransactionId,
    setCheckoutOpportunityReserversdAmount,
    setCheckoutOpportunityPaymentMethod,
    setCheckoutOpportunityCoupon,
    addCheckoutOpportunityAttachment,
    addCheckoutOpportunityCourse,
    addCheckoutOpportunityProgram,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
} from 'store';

const Wrapper = styled.section`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${css.colors.main};
    width: 100%;
    height: 100vh;
    top:0;
    left:0;
    overflow-y: auto;
    z-index: 999;
`

const LoaderWrapper = styled.div`
    margin: 0 auto;
    padding: 30px;
    max-width: 50%;
`

const Error = styled.div`
    display: flex;
    background: #F3E2E1;
    padding: 15px;
    margin-bottom: 30px;
    border-bottom: 4px solid #FF3232;
    align-items: center;
    justify-content: space-between;
`

class ManualRegistration extends Component {
    constructor() {
        super()
        this.state = {
            opportunityLoaded: null
        }
    }

    componentDidMount() {
        this.props.setCheckoutMinimizeButton(false);

        this.setState({ opportunityLoaded: false });

        const ref = new URLSearchParams(this.props.location.search).get('ref');

        if (!ref) {
            this.props.setCheckoutError(msg('unableRetrieveRegistration'));

            return;
        }

        Promise.all([
            api.coursesFetcher.getAll(),
            api.programsFetcher.getAll()
        ]).then(() => {
            this._onLoadOportunity(ref);
        });

        gtmPush({
            'event': 'GAEvent',  
            'eventCategory': 'checkout',  
            'eventAction': 'open',  
            'eventLabel': 'Open Checkout',  
            'eventValue': 20,  
            'nonInteraction': false
        })
    }

    _onLoadOportunity = async (ref) => {
        await api.getOpportunityByToken(ref).then(response => {
            this.props.setCheckoutCustomerId(response.data.customerId);

            this.props.setCheckoutOpportunityId(response.data.id);
            this.props.setCheckoutOpportunityCustomerId(response.data.customerId);
            this.props.setCheckountOpportunityEducationalGoal(response.data.educationalGoal);
            this.props.setCheckoutOpportunityComment(response.data.comment);
            this.props.setCheckoutOpportunityTransactionId(response.data.transactionId);
            this.props.setCheckoutOpportunityReserversdAmount(response.data.reservedAmount);
            this.props.setCheckoutOpportunityPaymentMethod(response.data.paymentMethod);
            this.props.setCheckoutOpportunityCoupon(response.data.coupon);
            this.props.setCheckoutOpportunityRegistrationType('SALESFORCE_LINK_CHECKOUT');

            response.data.attachments.forEach(attachment => {
                this.props.addCheckoutOpportunityAttachment(attachment);
            });

            response.data.courses.forEach(course => {
                // temporarely use offering id as course id of bundled courses
                // solution designed to keep backwards compatibility with existing apis
                let courseObj = this.props.courses.filter(item => item.offeringId === course.id); // data from wordpress 

                if (courseObj.length) {
                    courseObj[0].price = course.price;
                    this.props.addCheckoutOpportunityCourse(courseObj[0]);
                }
            });
            response.data.programs.forEach(program => {
                let programObj = this.props.programs.filter(item => item.id === program.id); // data from wordpress

                if (programObj.length) {
                    let priceSum = program.bundledCourses.reduce((accumulator, current) => {
                        return accumulator + current.price;
                    }, 0);

                    programObj[0].price = priceSum;
                    programObj[0].bundledCourses = program.bundledCourses;

                    this.props.addCheckoutOpportunityProgram(programObj[0]);
                }
            });

            this.props.setCheckoutCustomerPartialObject(true);
            this.props.setCheckoutOpportunityPartialObject(true);

            this.setState({ opportunityLoaded: true });
        }).catch(error => {
            this.props.setCheckoutError(msg('unableRetrieveRegistration'));
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.opportunityLoaded !== this.state.opportunityLoaded) {
            if (this.state.opportunityLoaded) {
                this.props.setCheckoutInitStep(4);
                this.props.setCheckoutVisibility(true);
            }
        }
    }

    render() {
        if (this.props.checkout.error) {
            return (
                <Wrapper>
                    <HeadMeta page={{
                        yoast: {
                            title: 'Bekreft Plass'
                        }
                    }} />
                    <Error>
                        <div className="message-wrapper">
                            <p className="message"> {this.props.checkout.error} </p>
                            <p className="advise"> {msg('pleaseContactAdvisor')} </p>
                        </div>
                    </Error>
                </Wrapper>
            );
        }

        if (!this.state.opportunityLoaded) {
            return (
                <Wrapper>
                    <HeadMeta page={{
                        yoast: {
                            title: 'Bekreft Plass'
                        }
                    }} />
                    <LoaderWrapper>
                        <Loader color="#fff" />
                    </LoaderWrapper>
                </Wrapper>
            );
        }

        return (
            <Wrapper>
                <HeadMeta page={{
                    yoast: {
                        title: 'Bekreft Plass'
                    }
                }} />
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    checkout: state.checkout,
    courses: state.courses.posts,
    programs: state.programs.posts,
    opportunity: state.opportunity,
});

const actions = {
    setCheckoutMinimizeButton,
    setCheckoutVisibility,
    setCheckoutInitStep,
    setCheckoutError,
    setCheckoutCustomerId,
    setCheckoutCustomerPartialObject,
    setCheckoutOpportunityPartialObject,
    setCheckoutOpportunityRegistrationType,
    setCheckoutOpportunityId,
    setCheckoutOpportunityCustomerId,
    setCheckountOpportunityEducationalGoal,
    setCheckoutOpportunityComment,
    setCheckoutOpportunityTransactionId,
    setCheckoutOpportunityReserversdAmount,
    setCheckoutOpportunityPaymentMethod,
    setCheckoutOpportunityCoupon,
    addCheckoutOpportunityAttachment,
    addCheckoutOpportunityCourse,
    addCheckoutOpportunityProgram,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
}

export default connect(mapStateToProps, actions)(withRouter(ManualRegistration));


// WEBPACK FOOTER //
// ./src/views/ManualRegistration.js